import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Detail } from 'app/models/detail.models';
import { environment } from 'environments/environment';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CajaService {

  public lstArticulos = new Subject<any>();
  public articulosList: Detail[] = [];

  constructor(private http: HttpClient) { }

  addArticulo(articulo: Detail) {
    this.articulosList.push(articulo);
    this.lstArticulos.next(this.articulosList);
  }

  quitarCobro(id) {
    this.articulosList.splice(this.articulosList.findIndex(x => x.id === id), 1);
    this.lstArticulos.next(this.articulosList);
  }

  editarCobro(indice, datos) {
    this.articulosList[indice] = datos;
    this.lstArticulos.next(this.articulosList);
  }

  eliminarListaArticulos() {
    this.articulosList = [];
    this.lstArticulos.next(this.articulosList);
  }

  eliminarDatosCargados(todosForm): any {
    todosForm.forEach(element => {
      this.articulosList.forEach(e => {
        if (e.id === element.id) {
          todosForm.splice(todosForm.indexOf(element), 1);
        }
      });
    });
    return todosForm;
  }

  // guardamos operación caja y genera el comprobante
  guardarOperacionCaja(dto) {
    return this.http.post(environment.apiUrl + 'cash-operation', dto);
  }

  // Obtener operaciones de caja por sesión y tipo
  getOperacionesCaja(cashSessionId: number, tipo?: string) {
    let url = environment.apiUrl + 'cash-operation/session/' + cashSessionId;
    if (tipo) {
      url += '?type=' + tipo;
    }
    return this.http.get(url);
  }

  // Actualizar operación de caja
  actualizarOperacionCaja(id: number, dto: any) {
    return this.http.patch(environment.apiUrl + 'cash-operation/' + id, dto);
  }

  // Eliminar operación de caja
  eliminarOperacionCaja(id: number) {
    return this.http.delete(environment.apiUrl + 'cash-operation/' + id);
  }

  // Obtener egresos de efectivo por sesión de caja
  getEgresosCaja(cashSessionId: number) {
    return this.http.get(environment.apiUrl + `cash-operation?operationTypeId=7&cashSessionId=${cashSessionId}`);
  }

}
